import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useAuth } from "../../../context/AuthContext";
import { useAlert } from "../../../context/AlertContext";
import { useLoading } from "../../../context/LoadingContext";
import { useWebsiteName } from "../../../context/WebsiteNameContext";
import { formatInputDate } from "../../../utils/Time";
import { autoDisplayValue } from "../../../commons/FormatValue";
import { getServiceRequest } from "../../../commons/ServiceRequest";
import {
  initializeSetOption,
  initializeSetOptionDisabled
} from "../../../utils/InitializeSetDefault";
import {
  FloatingControlComponent,
  SearchSelectComponent
} from "../../FormComponent";
import {
  emptyValueObjects,
  filteredCreateNewKey,
  filteredItemBySearch,
  findItemInArray,
  hasDuplicateValues
} from "../../../utils/ManageArray";
import TableForm from "../../TableForm";
import ButtonLink from "../../ButtonLink";
import ConfirmModal from "../../ConfirmModal";
import SearchFilter from "../../SearchFilter";
import ItemsService from "../../../services/item.service";
import DownTimesService from "../../../services/downtime.service";
import CustContractsService from "../../../services/custcontract.service";
import CustContractItemsService from "../../../services/custcontractitem.service";
import CardDisplayComponent from "../../CardDisplayComponent";

const BindingForm = ({ onSubmitCallback }) => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { user } = useAuth();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const { websiteName } = useWebsiteName();
  const [showModal, setShowModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const defaultData = {
    Contract_No: "",
    Contract_Type: "",
    PM_Per_Year: "",
    Item_Id: "",
    Dt_Id: "",
    Item_Location: "",
    Change_Pm_Per_Year: "",
    Reason_Change_Pm_Per_Year: "",
    Com_Code: user.Com_Code
  };
  const [data, setData] = useState({ Array: [defaultData] });
  const [item, setItem] = useState([]);
  const [contract, setContract] = useState([]);
  const [downTime, setDownTime] = useState([]);
  const [contractItem, setContractItem] = useState([]);
  const rowData = data?.Array?.[0];
  const searchInput = [
    {
      name: "Contract_No",
      label: "เลขที่สัญญา",
      classNames: { col: "mb-3", label: "mb-1" },
      queryService: (query) => queryCustContract(query)
    },
    {
      name: "Contract_Type",
      label: "ประเภทสัญญา",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "text",
      size: state?.type === "copy" ? 3 : null,
      disabled: true,
      findValue: { value: "Contract_No" }
    },
    {
      name: "PM_Per_Year",
      label: "จำนวน PM/ปี",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "number",
      min: 0,
      size: null,
      disabled: true,
      findValue: { value: "Contract_No" }
    },
    {
      name: "Change_Pm_Per_Year",
      label: "เปลี่ยนจำนวน PM/ปี",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "number",
      min: 0,
      size: null,
      disabled: true,
      findValue: { value: "Contract_No" }
    },
    {
      name: "Reason_Change_Pm_Per_Year",
      label: "สาเหตุที่เปลี่ยนจำนวน PM/ปี",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "text",
      disabled: true,
      findValue: { value: "Contract_No" }
    },
    {
      name: "CustContract.Contract_Start_Date",
      label: "วันที่เริ่มต้นสัญญา",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "date",
      disabled: true,
      findValue: { value: "Contract_No" }
    },
    {
      name: "CustContract.Contract_End_Date",
      label: "วันที่สิ้นสุดสัญญา",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "date",
      disabled: true,
      findValue: { value: "Contract_No" }
    },
    {
      name: "CustContract.Customer.Cus_Code",
      label: "รหัสลูกค้า/สาขา",
      type: "text",
      disabled: true,
      findValue: { value: "Contract_No" }
    },
    {
      name: "CustContract.Customer.Cus_NumBranch",
      label: "เลขที่สาขา",
      type: "text",
      size: "1_5",
      disabled: true,
      findValue: { value: "Contract_No" }
    },
    {
      name: "CustContract.Customer.Cus_Name",
      label: "ชื่อลูกค้า/สาขา",
      type: "text",
      disabled: true,
      findValue: { value: "Contract_No" },
      size: "4_5"
    }
  ];
  const inputField = [
    {
      name: "Contract_No",
      label: "เลขที่สัญญา",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "select",
      options: initializeSetOptionDisabled(
        { key: "Contract_No", dataset: contract },
        { key: "Contract_No", data: contractItem }
      ),
      queryService: (query) => queryCustContract(query)
    },
    {
      name: "Contract_Type",
      label: "ประเภทสัญญา",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "select",
      size: null,
      disabled: state?.name === "binding" && !!state?.type,
      noneAsync: true,
      options: [
        { value: "สัญญาตั้งต้น", label: "สัญญาตั้งต้น" },
        { value: "สัญญา PM", label: "สัญญา PM" },
        { value: "สัญญาขาย", label: "สัญญาขาย" },
        { value: "สัญญางานติดตั้ง", label: "สัญญางานติดตั้ง" },
        { value: "ต่อสัญญาใหม่", label: "ต่อสัญญาใหม่" }
      ]
    },
    {
      name: "PM_Per_Year",
      label: "จำนวน PM/ปี",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "number",
      min: 0,
      size: null,
      required: true,
      disabled: state?.name === "binding" && !!state?.type,
      findValue: { value: "Contract_No" }
    },
    {
      name: "Contract_Start_Date",
      label: "วันที่เริ่มต้นสัญญา",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "date",
      disabled: true,
      findValue: { data: contract, key: "Contract_No", value: "Contract_No" }
    },
    {
      name: "Contract_End_Date",
      label: "วันที่สิ้นสุดสัญญา",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "date",
      disabled: true,
      findValue: { data: contract, key: "Contract_No", value: "Contract_No" }
    },
    {
      name: "Customer.Cus_Code",
      label: "รหัสลูกค้า/สาขา",
      classNames:
        state?.type === "copy" ? { col: "mb-3", label: "mb-1" } : null,
      type: "text",
      disabled: true,
      findValue: { data: contract, key: "Contract_No", value: "Contract_No" }
    },
    {
      name: "Customer.Cus_NumBranch",
      label: "เลขที่สาขา",
      type: "text",
      disabled: true,
      findValue: { data: contract, key: "Contract_No", value: "Contract_No" },
      size: "1_5"
    },
    {
      name: "Customer.Cus_Name",
      label: "ชื่อลูกค้า/สาขา",
      type: "text",
      disabled: true,
      findValue: { data: contract, key: "Contract_No", value: "Contract_No" },
      size: state?.type === "copy" ? "7_5" : "4_5"
    }
  ];
  const inputChangeField = [
    {
      name: "Change_Pm_Per_Year",
      label: "เปลี่ยนจำนวน PM/ปี",
      type: "number",
      min: 0,
      findValue: { value: "Contract_No" }
    },
    {
      name: "Reason_Change_Pm_Per_Year",
      label: "สาเหตุที่เปลี่ยนจำนวน PM/ปี",
      type: "text",
      size: 6,
      findValue: { value: "Contract_No" }
    }
  ];
  const columns = [
    {
      name: "Project_No",
      label: "เลขที่โครงการ",
      type: "text",
      readOnly: true,
      findValue: { data: contract, key: "Contract_No", value: "Contract_No" }
    },
    {
      name: "Contract_No",
      label: "เลขที่สัญญา",
      type: "text",
      readOnly: true,
      findValue: { data: contract, key: "Contract_No", value: "Contract_No" }
    },
    {
      name: "Item_Id",
      label: "รหัสสินค้า",
      type: "select",
      readOnly: true,
      size: 2,
      filterBy: ["Item_Code"],
      options: initializeSetOption({
        key: "Id",
        label: "Item_Code",
        dataset: item
      }),
      queryService: (query) =>
        getServiceRequest({
          showAlert,
          setLoading,
          serviceRequest: ItemsService.getAllItems(query),
          callback: ({ items }) => setItem(items)
        })
    },
    {
      name: "Item_Name_TH",
      label: "รายละเอียดสินค้า",
      type: "text",
      readOnly: true,
      findValue: { data: item, key: "Id", value: "Item_Id" },
      size: 3
    },
    {
      name: "Dt_Id",
      label: "ประเภทบริการ",
      type: "select",
      readOnly: true,
      minKeywordLength: 1,
      filterBy: ["DT_Name"],
      options: initializeSetOption({
        key: "Id",
        label: "DT_Name",
        dataset: downTime
      })
    }
  ];

  const queryCustContract = (query) => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: CustContractsService.getAllCustContracts(query),
      callback: ({ items }) => setContract(items)
    });
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: CustContractItemsService.getAllCustContractItems(query),
      callback: ({ items }) => setContractItem(items)
    });
  };

  const handleSearchFilter = (search) => {
    const newSearch = filteredCreateNewKey({
      data: contract,
      search,
      newName: "Contract_No"
    });

    let filteredData = filteredItemBySearch(contractItem, newSearch);
    filteredData.forEach(({ Item }) => setItem((prev) => [...prev, Item]));

    if (state?.type === "copy") {
      filteredData = filteredData.map(
        ({ PM_Per_Year, Item_Id, Dt_Id, Item_Location, Com_Code }) => ({
          Contract_No: "",
          Contract_Type: "",
          PM_Per_Year,
          Item_Id,
          Dt_Id,
          Item_Location,
          Change_Pm_Per_Year: "",
          Reason_Change_Pm_Per_Year: "",
          Com_Code
        })
      );
    }

    setData({ Array: filteredData?.length ? filteredData : [defaultData] });
  };

  const checkValidity = () => {
    if (hasDuplicateValues(data.Array, ["Item_Id"])) {
      showAlert({
        error: "ข้อผิดพลาด",
        message: "รหัสอะไหล่ซ้ำกัน กรุณาเลือกรหัสอะไหล่ใหม่อีกครั้ง",
        type: "danger"
      });
      return false;
    }

    const passEmpty = [
      "Item_Location",
      "Change_Pm_Per_Year",
      "Reason_Change_Pm_Per_Year"
    ];
    if (emptyValueObjects(data.Array, passEmpty).length > 0) {
      showAlert({
        error: "ข้อผิดพลาด",
        message:
          rowData?.Contract_No === ""
            ? "กรุณาเลือกเลขที่สัญญา"
            : "กรุณากรอกข้อมูลให้ครบถ้วน",
        type: "danger"
      });
      return false;
    }
    return true;
  };

  const handleValidated = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (!form.checkValidity() || !checkValidity()) {
      event.stopPropagation();
      setValidated(true);
    } else {
      setShowModal(true);
    }
  };

  const handleSubmit = (event, { dataCallback, showCallback }) => {
    event.preventDefault();
    setShowModal(showCallback);

    if (dataCallback) onSubmitCallback(dataCallback);
  };

  useEffect(() => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: DownTimesService.getAllDownTimes(),
      callback: (res) => setDownTime(res)
    });
  }, []);

  useEffect(() => {
    const findContract = findItemInArray(
      contract,
      "Contract_No",
      rowData?.Contract_No
    );

    if (findContract) {
      const { Contract_Start_Date, Contract_End_Date, Cus_Id, Project_No } =
        findContract;
      setData({
        Array: data.Array.map((item) => ({
          ...item,
          Contract_Start_Date: formatInputDate(Contract_Start_Date, "Local")
            .date,
          Contract_End_Date: formatInputDate(Contract_End_Date, "Local").date,
          Cus_Id,
          Project_No
        }))
      });
    }
  }, [rowData?.Contract_No]);

  return (
    <>
      {["edit", "copy"].includes(state?.type) && (
        <CardDisplayComponent
          header={{
            title: {
              text:
                state?.type === "copy"
                  ? "เลือกสัญญาที่จะคัดลอก"
                  : "แก้ไขข้อมูลการผูกสัญญา",
              className: "text-center"
            }
          }}
          body={{
            element: (
              <SearchFilter
                data={contractItem}
                inputField={
                  state?.type === "copy"
                    ? searchInput.filter(({ type }) => type !== "date")
                    : searchInput.filter(
                        ({ name }) =>
                          ![
                            "Change_Pm_Per_Year",
                            "Reason_Change_Pm_Per_Year"
                          ].includes(name)
                      )
                }
                fieldClassName={{
                  inputRow: `justify-content-${
                    state?.type === "copy" ? "center" : "end"
                  } align-items-center`,
                  actionButton: "text-start"
                }}
                searchCallback={(search) => {
                  setItem([]);
                  search.some(({ value }) => value)
                    ? handleSearchFilter(search)
                    : setData({ Array: [defaultData] });
                }}
              />
            )
          }}
        />
      )}

      <Form noValidate validated={validated} onSubmit={handleValidated}>
        {state?.type !== "edit" ? (
          <CardDisplayComponent
            header={
              state?.type === "copy"
                ? {
                    title: {
                      text: "เลือกสัญญาที่จะสร้าง",
                      className: "text-center"
                    }
                  }
                : null
            }
            body={{
              as: Row,
              element: (
                <>
                  {inputField.map(
                    (
                      {
                        name,
                        label,
                        classNames,
                        type,
                        size,
                        min,
                        options,
                        noneAsync,
                        queryService,
                        findValue,
                        required,
                        disabled,
                        filterBy
                      },
                      idx
                    ) => {
                      const value =
                        (findValue &&
                          autoDisplayValue({
                            name,
                            type,
                            findValue: {
                              ...findValue,
                              value: rowData?.[findValue.value]
                            }
                          })) ||
                        rowData?.[name];

                      return (
                        <Col
                          key={idx}
                          sm={size ? size : size === null ? null : 3}
                          className={classNames?.col}
                        >
                          {type === "select" ? (
                            <SearchSelectComponent
                              floatingClass={classNames?.label}
                              labelField={label}
                              filterBy={filterBy}
                              options={options}
                              isInvalid={rowData?.[name] === ""}
                              noneAsync={noneAsync}
                              queryService={queryService}
                              placeholder="โปรดเลือก"
                              onChange={(change) =>
                                setData({
                                  Array: data.Array.map((item) => ({
                                    ...item,
                                    [name]: change?.value
                                  }))
                                })
                              }
                              value={`${value}`}
                            />
                          ) : (
                            <FloatingControlComponent
                              min={min}
                              type={type}
                              name={name}
                              label={label}
                              required={required}
                              disabled={disabled}
                              placeholder="โปรดระบุ"
                              onChange={({ target }) =>
                                setData({
                                  Array: data.Array.map((item) => ({
                                    ...item,
                                    [name]: target.value
                                  }))
                                })
                              }
                              value={value}
                            />
                          )}
                        </Col>
                      );
                    }
                  )}

                  {state?.type !== "copy" &&
                    [
                      { name: "edit", label: "แก้ไข" },
                      { name: "delete", label: "ลบ" },
                      { name: "copy", label: "คัดลอก" }
                    ].map(({ name, label }, idx) => (
                      <Col key={`button-${idx}`} className="m-0 pe-0 py-1">
                        <ButtonLink
                          linkTo={name}
                          stateData={{ name: "binding", type: name }}
                          buttonClass="w-100 py-2 text-dark rounded-pill"
                          buttonName={label}
                        />
                      </Col>
                    ))}
                </>
              )
            }}
          />
        ) : (
          <CardDisplayComponent
            header={{
              title: { text: "แก้ไขจำนวน PM/ปี", className: "text-center" }
            }}
            body={{
              as: Row,
              className: "justify-content-center",
              element: inputChangeField.map(
                ({ name, label, type, size, min, findValue }, idx) => {
                  const value =
                    (findValue &&
                      autoDisplayValue({
                        name,
                        type,
                        findValue: {
                          ...findValue,
                          value: rowData?.[findValue.value]
                        }
                      })) ||
                    rowData?.[name];

                  return (
                    <Col key={idx} sm={size || 3}>
                      <FloatingControlComponent
                        min={min}
                        type={type}
                        name={name}
                        label={label}
                        placeholder="โปรดระบุ"
                        onChange={({ target }) =>
                          setData({
                            Array: data.Array.map((item) => ({
                              ...item,
                              [name]: target.value
                            }))
                          })
                        }
                        value={value}
                      />
                    </Col>
                  );
                }
              )
            }}
          />
        )}

        <CardDisplayComponent
          header={{
            title: {
              text:
                state?.type === "copy"
                  ? "เพิ่ม-แก้ไข รายละเอียดสัญญาที่จะสร้าง"
                  : websiteName
            }
          }}
          body={{
            element: (
              <TableForm
                data={data.Array}
                columns={columns}
                defaultData={defaultData}
                duplicateKey={["Item_Id"]}
                activeButton={
                  state?.type === "edit"
                    ? ["add", "copy"]
                    : ["add", "copy", "delete"]
                }
                onChangeCallback={(newData) =>
                  setData({
                    Array: newData.map((item) => ({
                      ...item,
                      Contract_No: rowData?.Contract_No,
                      Contract_Type: rowData?.Contract_Type,
                      PM_Per_Year: rowData?.PM_Per_Year
                    }))
                  })
                }
              />
            )
          }}
          footer={{
            className: "text-end",
            element: (
              <>
                <Button
                  type="submit"
                  variant="success"
                  className="px-5 py-2 text-dark rounded-pill"
                >
                  {state?.type === "edit" ? "บันทึกการแก้ไข" : "บันทึกข้อมูล"}
                </Button>
                {showModal && (
                  <ConfirmModal
                    show={showModal}
                    data={data}
                    content="edit"
                    onSubmitCallback={handleSubmit}
                  />
                )}

                {["edit", "copy"].includes(state?.type) && (
                  <Button
                    variant="outline-success"
                    className="px-5 py-2 text-dark border-secondary rounded-pill"
                    onClick={() =>
                      navigate("/PM_work/bind", { state: { name: "binding" } })
                    }
                  >
                    ยกเลิก
                  </Button>
                )}
              </>
            )
          }}
        />
      </Form>
    </>
  );
};

BindingForm.propTypes = { onSubmitCallback: PropTypes.func };

export default BindingForm;
